export default __webpack_public_path__ + "static/media/getTotalsButton.44594f54.gif";